import { render, staticRenderFns } from "./RankingItem.vue?vue&type=template&id=b43817b2"
import script from "./RankingItem.vue?vue&type=script&lang=js"
export * from "./RankingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports